<template>
  <div>
    <PageTitle title="My Activities" />
    <v-sheet class="overflow-hidden" style="position: relative">
      <v-container fluid class="lighten-12">
        <v-timeline
          align-top
          :dense="$vuetify.breakpoint.smAndDown"
          class="scrollbar scrolllist"
        >
          <v-timeline-item
            v-for="(item, i) in items"
            :key="i"
            :color="item.color"
            :icon="item.icon"
            fill-dot
          >
            <v-card>
              <v-row>
                <v-col cols="4" style="text-align: center">
                  <b> {{ item.activity }} </b>
                </v-col>
                <v-col cols="5" style="text-align: center">
                  {{ item.date }}</v-col
                >
                <v-col cols="3" style="text-align: center">
                  <v-btn
                    :color="item.color"
                    style="height: 30px"
                    outlined
                    @click.stop="getSingleView(item.id)"
                  >
                    <v-icon style="margin-right: 5px">mdi-eye</v-icon>
                    View
                  </v-btn></v-col
                >
              </v-row>
            </v-card>
          </v-timeline-item>
        </v-timeline>
      </v-container>
      <v-navigation-drawer
        v-model="drawer"
        width="900px"
        height="652"
        absolute
        temporary
        right
      >
        <v-list-item>
          <v-list-item-avatar>
            <v-img src="https://randomuser.me/api/portraits/men/78.jpg"></v-img>
          </v-list-item-avatar>

          <v-list-item-content>
            <v-list-item-title
              ><b>
                {{ items1.causer ? items1.causer.first_name : '' }} ({{
                  items1.ip
                }})</b
              >
            </v-list-item-title>
            <span>{{ items1.causer ? items1.created_at : '' }}</span>
          </v-list-item-content>
        </v-list-item>

        <v-divider></v-divider>

        <v-list dense>
          <table>
            <tbody>
              <tr>
                <th>Attributes</th>
                <th>Old Values</th>
                <th>New Values</th>
              </tr>
              <tr>
                <td>
                  <div
                    v-for="(item, index) in items1.fields"
                    :key="index"
                    style="height: 35px"
                  >
                    {{ item }}
                  </div>
                </td>
                <td>
                  <div
                    v-for="(item, index) in items1.fields"
                    :key="index"
                    style="text-align: start; margin: 1px"
                  >
                    <div
                      :style="{
                        background:
                          items1.attributes[item] != items1.old[item]
                            ? '#ffeeba'
                            : 'none',
                      }"
                      style="height: 35px; padding-top: 7px"
                    >
                      {{ items1.old[item] ? items1.old[item] : 'Null' }}
                    </div>
                  </div>
                </td>
                <td>
                  <div
                    v-for="(item, index) in items1.fields"
                    :key="index"
                    style="text-align: start; margin: 1px"
                  >
                    <div
                      :style="{
                        background:
                          items1.attributes[item] != items1.old[item]
                            ? '#c3e6cb'
                            : 'none',
                      }"
                      style="height: 35px; padding-top: 7px"
                    >
                      {{
                        items1.attributes[item]
                          ? items1.attributes[item]
                          : 'Null'
                      }}
                    </div>
                  </div>
                </td>
              </tr>
            </tbody>
          </table>
        </v-list>
      </v-navigation-drawer>
    </v-sheet>

    <v-row>
      <v-col cols="12">
        <pagination
          url="auth/activities"
          @response="receiveActivitydatas"
          ref="pagination"
        />
      </v-col>
    </v-row>
  </div>
</template>

<script>
import axios from '@/plugins/axios';
import { Activicty } from '../../models/Activicty';
import pagination from '../shared/components/Paginationversion.vue';

export default {
  data: () => ({
    items: new Activicty(),
    paginationOptions: {},
    drawer: null,

    items1: {},
  }),
  components: { pagination },
  methods: {
    setPaginationOptions(data) {
      this.paginationOptions = data;
    },
    receiveActivitydatas(data) {
      this.items = new Activicty().toListView(data);
    },
    getSingleView(id) {
      axios
        .get(`audit-logs/${id}`)
        .then((res) => {
          this.drawer = 'gh';
          this.items1 = res.data.data;
        })
        .catch((err) => {
          this.messages = err.data.title;
        });
    },
    GetAllActivicies() {
      axios
        .get(`auth/activities`)
        .then((res) => {
          this.items = new Activicty().toListView(res.data.data);
        })
        .catch((err) => {
          this.messages = err.data.title;
        });
    },
  },
  created() {
    this.$store.commit('REMOVE_FILTERDATAS');
    this.$store.commit('UPDATE_PAGINATION_PAGE_SIZE', 15);
    // this.GetAllActivicies();
  },
};
</script>
<style scoped>
@import url('https://fonts.googleapis.com/css2?family=Source+Sans+Pro&display=swap');

.scrolllist {
  max-height: 520px;
  width: 100%;
  overflow: auto;
  font-family: 'Source Sans Pro', sans-serif;
}
table {
  width: 100%;
  margin: 5px;
}
</style>
